import { render, staticRenderFns } from "./DriverWidget.vue?vue&type=template&id=347e3b88&scoped=true&"
import script from "./DriverWidget.vue?vue&type=script&lang=js&"
export * from "./DriverWidget.vue?vue&type=script&lang=js&"
import style0 from "./DriverWidget.vue?vue&type=style&index=0&id=347e3b88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347e3b88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('347e3b88')) {
      api.createRecord('347e3b88', component.options)
    } else {
      api.reload('347e3b88', component.options)
    }
    module.hot.accept("./DriverWidget.vue?vue&type=template&id=347e3b88&scoped=true&", function () {
      api.rerender('347e3b88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/DriverWidget.vue"
export default component.exports